export default function RoundedCheckbox({name, disabled, ...rest}) {
    return (
        <label className={`rounded-checkbox ${disabled ? 'disabled' : ''}`} htmlFor={name}>
            <input type="checkbox"
                   id={name}
                   name={name}
                   disabled={disabled}
                   {...rest}
            />
            <div className="inner"/>
        </label>
    )
}
